import { get } from "./base";

// singleton batches state
const batches = {};
const cacheMap = new Map();

const DeliveryEstimateServ = {
    getEstimate: (params) => {
        const { shopId, latitude, longitude, addressId } = params;
        const sIds = (Array.isArray(shopId) ? shopId : [shopId]).map(id => id?.toString().toLowerCase());
        // Normalize: backend reads `lat`/`lng` — not `latitude`/`longitude`
        const cacheKeyBase = `${latitude}_${longitude}_${addressId || ''}`;

        return new Promise((resolve, reject) => {
            const missingIds = sIds.filter(id => !cacheMap.has(`${cacheKeyBase}_${id}`));
            if (missingIds.length === 0) {
                return resolve({ 
                    data: sIds.map(id => cacheMap.get(`${cacheKeyBase}_${id}`)),
                    summary: cacheMap.get(`${cacheKeyBase}_summary`)
                });
            }

            if (!batches[cacheKeyBase]) {
                batches[cacheKeyBase] = {
                    queue: new Set(),
                    subscribers: [],
                    timeout: null,
                    params
                };
            }

            const b = batches[cacheKeyBase];
            missingIds.forEach(id => b.queue.add(id));
            b.subscribers.push({ ids: sIds, resolve, reject });

            if (!b.timeout) {
                b.timeout = setTimeout(async () => {
                    const currentQueue = [...b.queue];
                    const currentSubscribers = [...b.subscribers];
                    const currentParams = b.params;

                    delete batches[cacheKeyBase];

                    try {
                        const res = await get("/Deliveries/estimate", {
                            params: { ...currentParams, shopId: currentQueue }
                        });

                        if (res?.data) {
                            res.data.forEach(item => {
                                cacheMap.set(`${cacheKeyBase}_${item.shopId?.toString().toLowerCase()}`, item);
                            });
                        }

                        if (res?.summary) {
                            cacheMap.set(`${cacheKeyBase}_summary`, res.summary);
                        }

                        currentSubscribers.forEach(sub => {
                            const results = sub.ids.map(id => cacheMap.get(`${cacheKeyBase}_${id}`)).filter(Boolean);
                            sub.resolve({ data: results, summary: res?.summary || cacheMap.get(`${cacheKeyBase}_summary`) });
                        });
                    } catch (error) {
                        currentSubscribers.forEach(sub => sub.reject(error));
                    }
                }, 50);
            }
        });
    }
};

export default DeliveryEstimateServ;
